import React from 'react';
import { formatScore, gapSeverityClass } from '@/components/assessment-engine/resultsScoreUtils';

interface GapValueProps {
  gap: number | null | undefined;
  /** One-sigma threshold for severity (cohort SD or scale σ). */
  sigma: number;
}

/** Formats a gap; colors by 1σ: green strength, yellow mild deficit, red large deficit. */
export const GapValue: React.FC<GapValueProps> = ({ gap, sigma }) => (
  <span className={gapSeverityClass(gap, sigma)}>{formatScore(gap)}</span>
);
